import React, { Component } from "react";

class DeleteUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
      >
        <path
          className="svg"
          d="M0.5,4.6L1.3,16H9L9.8,4.6L0.5,4.6z M3.3,14C3.1,14,3,13.9,3,13.7L2.9,7.3C2.9,7.2,3,7,3.2,7
	c0.1,0,0.3,0.2,0.3,0.3l0.2,6.3C3.6,13.8,3.5,14,3.3,14z M5.5,13.7c0,0.1-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3V7.4
	C4.9,7.2,5,7,5.2,7c0.1,0,0.3,0.2,0.3,0.3V13.7z M7.3,13.7C7.3,13.9,7.2,14,7,14c-0.2,0-0.3-0.1-0.3-0.3l0.2-6.3C6.9,7.2,7,7,7.2,7
	c0.2,0,0.3,0.1,0.3,0.3L7.3,13.7z M10.2,2.4L7.6,1.9l0.1-0.8c0-0.2-0.1-0.4-0.3-0.4L3.9,0C3.7,0,3.5,0.1,3.5,0.3L3.3,1.1L0.8,0.6
	C0.5,0.5,0.3,0.7,0.3,0.9L0,2.2c0,0.2,0.1,0.5,0.3,0.5l9.5,1.8c0.2,0,0.5-0.1,0.5-0.3L10.5,3C10.6,2.6,10.5,2.4,10.2,2.4z M4.1,0.8
	L7,1.3L6.9,1.7L4.1,1.2V0.8z M15.5,16h-4.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.9V1.1h-4.4c-0.3,0-0.5-0.2-0.5-0.5
	S10.2,0,10.5,0h4.9C15.8,0,16,0.2,16,0.5v14.9C16,15.8,15.8,16,15.5,16z M13.7,3c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8
	s0.4-0.8,0.8-0.8C13.4,2.2,13.7,2.5,13.7,3z"
        />
      </svg>
    );
  }
}

export default DeleteUpSVG;



// WEBPACK FOOTER //
// ./src/svg/DeleteUpSVG.jsx